var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'col-md-4',
    'my-1',
    'mx-auto',
    'box',
    _vm.back ? 'with-back' : '',
    _vm.$activeLang == 'ar' ? 'text-md-end' : 'text-md-start' ]},[_c('div',{staticClass:"icon mx-auto mx-md-0"},[_c('img',{attrs:{"src":_vm.dataCard.img,"alt":"icon"}})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataCard.title))]),_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.dataCard.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }